import React from 'react'
import {useSelector} from 'react-redux'
import Select from 'react-select'
import { getPlanData } from '../../features/Plan';

function PlanDropDown(props) {
    const plandata = useSelector(getPlanData);
    const selectdata=plandata.map((data)=>{
      return {
      value:data.plan_id,
      label:data.name
      }
    })
    const index=selectdata.findIndex(checkplan)
    function checkplan(data) {
      return data.value== props.defaultValue;
    }
  return (
    <div style={{width: "100%"}}>
      <Select 
        options={selectdata}  
        onChange={(value)=>{props?.searchParam ? props.searchParam(value.value,"plan_id"):props.action(value.value)}}
        defaultValue={selectdata[index]}
      />
    </div>
  )
}

export default PlanDropDown